// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const EyeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Eye/solid"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}))));
export default EyeIcon;